import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'

import {withRouter} from "react-router-dom";
import {message, Modal} from "antd";
import 'react-multi-select-panel/index.css'
import {normaluserlist, usernormaldelete} from "../../../servers/goodsManageApi";


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.addHandler = this.addHandler.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.onChange = this.onChange.bind(this)
    this.computeddata = this.computeddata.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    page: tableData.tPage,
    addqx:[],
    loading: false,
    showoperate:true
  };

  onChange(data){
    let params = []
    let noselect = []
    this.state.dataSource.forEach(item=>{
      item.expertlist.forEach(item=>{
        item.title = item.name
      })
      if (item.id === data) {
        params = item.expertlist
      }  else {
        noselect.push(item.expertlist)
      }
    })
    this.setState({
      selectedOptions:params,
      value:data,
      noSelectedOptions:noselect.concat(this.state.nogroupexpertlist)
    });
  }

  // 获取用户列表数据
  getListData(){
    let getData = {
      id: ''
    };
    this.setState({
      loading: true
    });
    normaluserlist(getData).then(res=>{
      let total = 1;
      this.setState({
        dataSource: res.records[0].datalist,
        page: {...this.state.page, total},
        addqx:res.records[0].rightlist,
        loading: false,
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  /*新增*/
  addHandler(){
    this.props.history.push({
      pathname: '/informationDeclaration/adduser',
      search: '?type=new'
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('userEdit', JSON.stringify(data))
    this.props.history.push({
      pathname: '/informationDeclaration/adduser',
      search: `?type=edit&id=${data.id}`
    })
  }

  onDelete(data){
    Modal.confirm({
      content: '确认删除该用户',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        const params = {
          id:data
        }
        usernormaldelete(params).then(res=>{
          if (res.statecode === 0) {
            message.success('删除成功');
            this.getListData()
          } else {
            message.error('删除失败');
          }
        })
      }
    });
  }

  computeddata(data){
    const result = []
    this.state.addqx.forEach(item=>{
      if (data.rights.includes(item.id)){
        result.push(item.name)
      }
    })
    const str = result.join(',')
    return str
  }

  componentWillMount(){

  }

  componentDidMount(){
    const user = JSON.parse(localStorage.getItem('userInfo'))[0].clerklist[0].rank
    if (user !== 1) {
      const data = JSON.parse(JSON.stringify(this.state.columns))
      data.splice(5,1)
      this.setState({
        columns:data
      })
    }
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              <CButton type='primary' authId='goodsManageListNewAdd' onClick={this.addHandler}>新增</CButton>
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='rights'
                render={(text, record, index) => (
                    <div className='operate'>
                      { this.computeddata(record)}
                    </div>
                )} />
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.fenpei(record)}>分配</CButton>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>编辑</CButton>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.onDelete(record.id)} style={{marginLeft:'20px'}}>删除</CButton>
                    </div>
                )} />
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
